import { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { API } from "../lib/api";

/**
 * /forgot-password — user enters their email. Backend replies 200 whether the
 * email exists or not (no user enumeration). We surface the same success
 * message either way.
 */
export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await axios.post(`${API}/auth/forgot-password`, { email: email.trim() });
      setSent(true);
    } catch (err) {
      toast.error("Couldn't send reset email. Try again in a moment.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#050510] text-white flex items-center justify-center p-6" data-testid="forgot-password-page">
      <div className="w-full max-w-md">
        <div className="text-[11px] tracking-[0.32em] uppercase text-[#2A5BFF]">Password</div>
        <h1 className="font-anton uppercase text-4xl md:text-5xl mt-4 leading-[0.95]">Forgot your password?</h1>

        {!sent ? (
          <form onSubmit={submit} className="mt-10">
            <label className="text-[10px] tracking-[0.32em] uppercase text-white/50">Email</label>
            <input
              type="email"
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="input-line focus-ring"
              data-testid="forgot-email"
            />
            <button
              type="submit"
              disabled={busy || !email}
              className="btn-primary mt-8 w-full px-6 py-4 text-[12px] tracking-[0.22em] uppercase font-medium disabled:opacity-60"
              data-testid="forgot-submit"
            >
              {busy ? "…" : "Send reset link"}
            </button>
          </form>
        ) : (
          <div className="mt-10 border border-white/10 p-6" data-testid="forgot-sent">
            <div className="text-[10px] tracking-[0.32em] uppercase text-white/40">Check your inbox</div>
            <p className="mt-3 text-white/80 text-sm leading-relaxed">
              If an account exists for <span className="text-white">{email}</span>, we've sent a password-reset link
              to it. The link expires in 60 minutes and can only be used once.
            </p>
          </div>
        )}

        <div className="mt-8 text-sm">
          <Link to="/" className="text-white/50 hover:text-[#2A5BFF] text-[11px] tracking-[0.24em] uppercase">
            ← Back home
          </Link>
        </div>
      </div>
    </div>
  );
}
